/**
 * Horizontal scroll behavior for any container.
 * Adds trackpad/shift+wheel horizontal scrolling and click-and-drag.
 *
 * Usage:
 *   Add data-horizontal-scroll attribute to any container with overflow-x: auto.
 *   <div class="my-carousel" data-horizontal-scroll>...</div>
 *
 * Or initialize manually:
 *   HorizontalScroll.init('.my-carousel');
 *   HorizontalScroll.attach(document.querySelector('.my-carousel'));
 */
(function () {
  'use strict';

  const DRAG_THRESHOLD = 5;

  function attach(el) {
    if (!el || el.dataset.horizontalScrollAttached === 'true') return;
    el.dataset.horizontalScrollAttached = 'true';

    // Wheel: intercept only horizontal intent (trackpad or shift+wheel)
    el.addEventListener('wheel', (e) => {
      if (e.deltaX === 0 && !e.shiftKey) return;
      if (el.scrollWidth <= el.clientWidth) return;
      e.preventDefault();
      const delta = e.deltaX !== 0 ? e.deltaX : e.deltaY;
      el.scrollLeft += delta;
    }, { passive: false });

    // Click and drag
    let isDown = false;
    let startX = 0;
    let scrollStart = 0;
    let hasDragged = false;

    el.addEventListener('mousedown', (e) => {
      isDown = true;
      hasDragged = false;
      startX = e.pageX - el.offsetLeft;
      scrollStart = el.scrollLeft;
    });

    el.addEventListener('mouseleave', () => {
      isDown = false;
      el.classList.remove('is-dragging');
    });

    el.addEventListener('mouseup', () => {
      isDown = false;
      setTimeout(() => {
        el.classList.remove('is-dragging');
      }, 50);
    });

    el.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      const x = e.pageX - el.offsetLeft;
      const walk = x - startX;

      if (!hasDragged && Math.abs(walk) > DRAG_THRESHOLD) {
        hasDragged = true;
        el.classList.add('is-dragging');
      }

      if (hasDragged) {
        e.preventDefault();
        el.scrollLeft = scrollStart - walk;
      }
    });
  }

  function init(selector) {
    if (typeof selector === 'string') {
      document.querySelectorAll(selector).forEach(attach);
    } else if (selector instanceof Element) {
      attach(selector);
    } else if (selector instanceof NodeList || Array.isArray(selector)) {
      selector.forEach(attach);
    }
  }

  function autoInit() {
    document.querySelectorAll('[data-horizontal-scroll]').forEach(attach);
  }

  // Auto-initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }

  // Expose globally for manual initialization
  window.HorizontalScroll = {
    init,
    attach,
    autoInit
  };
})();